import { createContext } from "react";

import { KeyValuePair } from "../models/key-value-pair";

export const TranslationContext = createContext<KeyValuePair<string>>({});
